import type { TransportOption } from 'tripPlanner/api/types'
import type { TripPlannerSurfaceActivityEntry } from 'tripPlanner/assistant/surfaceSnapshots/surfaceActivityEntryTypes'
import { boundActivityDisplayText } from 'tripPlanner/assistant/surfaceSnapshots/surfaceActivityDisplayText'
import { getTransportOptionLabel } from '../utils/transportOptionUtils'

export function buildDefaultTransportSwitchedActivityEntry(
  previousOption: TransportOption,
  newOption: TransportOption,
): TripPlannerSurfaceActivityEntry {
  return {
    kind: 'default_transport_switched',
    label: 'Changed default transport',
    displayText: boundActivityDisplayText(
      `Switched default transport from "${getTransportOptionLabel(previousOption)}" to "${getTransportOptionLabel(newOption)}"`,
    ),
    sourcePath: 'trip_planner.transport.switch_default',
    dataClassification: 'personalised_surface',
    occurredAt: new Date().toISOString(),
  }
}
